module.exports = __webpack_public_path__ + "img/aidmodel_sm.876e1f51.png";